import { useLazyQuery } from '@apollo/client';
import { exportXlsModal } from 'motion-components';
import { gqlGetQuery } from '../graphql';
import { buildWhereFromFilterValues } from './filters';
import { useState } from 'react';
import { format, parseISO } from 'date-fns';
import { isAfisCyprus } from 'shared-pages/common/constants';

export const exportColumns = (t) => {
  return [
    { fieldName: 'id', fieldTitle: t('ID'), fieldType: 'TEXT' },
    { fieldName: 'name', fieldTitle: t('Επωνυμία Συλλέκτη'), fieldType: 'TEXT' },
    { fieldName: 'addressLine1', fieldTitle: t('Διεύθυνση'), fieldType: 'TEXT' },
    { fieldName: 'addressLine2', fieldTitle: t('Διεύθυνση 2'), fieldType: 'TEXT' },
    { fieldName: 'addressArea', fieldTitle: t('Περιοχή'), fieldType: 'TEXT' },
    { fieldName: 'addressCity', fieldTitle: t('Πόλη'), fieldType: 'TEXT' },
    { fieldName: 'postalCode', fieldTitle: t('Τ.Κ.'), fieldType: 'TEXT' },
    { fieldName: 'phone', fieldTitle: t('Τηλέφωνο'), fieldType: 'TEXT' },
    { fieldName: 'companyVat', fieldTitle: t('Α.Φ.Μ.'), fieldType: 'TEXT' },
    ...(!isAfisCyprus
      ? [{ fieldName: 'companyTaxOffice', fieldTitle: t('Δ.Ο.Υ.'), fieldType: 'TEXT' }]
      : []),

    { fieldName: 'imaCode', fieldTitle: t('Αριθμός Η.Μ.Α.'), fieldType: 'TEXT' },
    { fieldName: 'contactPerson', fieldTitle: t('Υπεύθυνος'), fieldType: 'TEXT' },
    { fieldName: 'contractNo', fieldTitle: t('Αριθμός Σύμβασης'), fieldType: 'TEXT' },
    {
      fieldName: 'contractSignDate',
      fieldTitle: t('Ημερομηνία Υπογραφής Σύμβασης'),
      fieldType: 'DATE',
    },
    { fieldName: 'contractExpDate', fieldTitle: t('Λήξη Σύμβασης'), fieldType: 'DATE' },
    {
      fieldName: 'insurancePolicyNumber',
      fieldTitle: t('Αριθμός Ασφαλιστηρίου'),
      fieldType: 'TEXT',
    },
    {
      fieldName: 'insuranceExpirationDate',
      fieldTitle: t('Λήξη Ασφαλιστήριου'),
      fieldType: 'DATE',
    },
    {
      fieldName: 'hazardousWastePermit',
      fieldTitle: t('Άδεια Μεταφοράς Επικίνδυνων'),
      fieldType: 'TEXT',
    },
    {
      fieldName: 'hazardousWasteExpDate',
      fieldTitle: t('Λήξη Άδειας Μεταφοράς'),
      fieldType: 'DATE',
    },
    { fieldName: 'environmentalPermit', fieldTitle: t('Περιβαντολογική Άδεια'), fieldType: 'TEXT' },
    {
      fieldName: 'envPermitExpirationDate',
      fieldTitle: t('Λήξη Περιβαντολογικής Άδειας'),
      fieldType: 'DATE',
    },
    {
      fieldName: 'adrConsultantAgrExpDate',
      fieldTitle: t('Λήξη Συμβόλαιου ADR'),
      fieldType: 'DATE',
    },

    { fieldName: 'isActive', fieldTitle: t('Ενεργή Εγγραφή'), fieldType: 'TEXT' },
    { fieldName: 'firstRec', fieldTitle: t('Δήλωση'), fieldType: 'TEXT' },
    { fieldName: 'lastRec', fieldTitle: t('Αλλαγή'), fieldType: 'TEXT' },
  ];
};

export async function handleExport(client, queryState: any, t): Promise<void> {
  function useGetQuery() {
    const [get, { loading }] = useLazyQuery(gqlGetQuery, { onCompleted: transformData });
    const [result, setResult] = useState<any>([get, { loading, data: undefined }]);
    function transformData(data) {
      const recs = data.getCollectors.data.map((values) => {
        return {
          ...values,
          isActive: !values.isActive ? t('ΟΧΙ') : t('ΝΑΙ'),
          firstRec: ` ${
            values.firstDate ? format(parseISO(values.firstDate), 'dd/MM/yy HH:mm') : ''
          }  - ${values.firstUser}`,
          lastRec: ` ${
            values.lastDate ? format(parseISO(values.lastDate), 'dd/MM/yy HH:mm') : ''
          }  - ${values.lastUser}`,
        };
      });
      const trsData = {
        getCollectors: { data: recs, recordCount: data?.getCollectors?.recordCount },
      };
      setResult([get, { loading, data: trsData }]);
    }
    return result;
  }
  const filterVariables = {
    where: buildWhereFromFilterValues(queryState?.filterValues),
  };
  await exportXlsModal({
    apolloClient: client,
    exportFileName: 'export Collectors',
    getLazyQuery: useGetQuery,
    columnsDef: exportColumns(t),
    filterVariables: filterVariables,
  });
}

